export var SET_EVENT_DATA = "SET_EVENT_DATA";
export var SAVE_EVENT_DATA = "SAVE_EVENT_DATA";
export var SAVE_GROUPS_DATA = "SAVE_GROUPS_DATA";
